import { apiInstance } from "../config/api";

type ListIncomingOrdersParams = {
  page?: number;
  limit?: number;
  search?: string;
  sellerAccountId?: string;
  profilerId?: string;
  marketId?: string;
};

type CreateIncomingOrderPayload = {
  profilerId: string;
  customerName: string;
  deliveryAddress?: string;
  specialInstructions?: string;
  estimatedTotal?: number;
  currency?: string;
  rawNotes?: string;
  items: Array<{
    name: string;
    quantity: number;
    unit?: string;
    unitPrice: number;
    notes?: string;
    productId?: string;
  }>;
};

export const incomingOrderService = {
  async listIncomingOrders({
    page,
    limit,
    search,
    sellerAccountId,
    profilerId,
    marketId,
  }: ListIncomingOrdersParams) {
    const response = await apiInstance.get("/product-management/incoming-orders", {
      params: {
        ...(typeof page === "number" ? { page } : {}),
        ...(typeof limit === "number" ? { limit } : {}),
        ...(search ? { search } : {}),
        ...(sellerAccountId ? { sellerAccountId } : {}),
        ...(profilerId ? { profilerId } : {}),
        ...(marketId ? { marketId } : {}),
      },
    });
    return response.data;
  },

  async getIncomingOrderById(orderId: string) {
    const response = await apiInstance.get(
      `/product-management/incoming-orders/${orderId}`,
    );
    return response.data;
  },

  async createIncomingOrder(payload: CreateIncomingOrderPayload) {
    const response = await apiInstance.post(
      "/product-management/customer-orders",
      payload,
    );
    return response.data;
  },
};